export default function Modal({ show, closeModal, children }) {
  return (
    <>
      {show ? (
        <div className="fixed top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 p-8 rounded-2xl border border-altDark/20 bg-dark/50 backdrop-blur-md z-50 w-11/12 md:w-fit">
          <div className="relative">
            <button
              className="absolute -top-16 left-1/2 -translate-x-1/2 w-16 h-16 p-3 rounded-full border-4 border-error shadow-error/50 flex items-center justify-center bg-dark shadow-glow"
              onClick={closeModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                viewBox="0 0 14.467 14.467"
              >
                <g
                  id="Group_2487"
                  data-name="Group 2487"
                  transform="translate(-208 -123)"
                >
                  <path
                    id="Path_1062"
                    data-name="Path 1062"
                    d="M20.67,18.36H3.93a.93.93,0,1,1,0-1.86H20.67a.93.93,0,1,1,0,1.86Z"
                    transform="translate(218.861 109.211) rotate(45)"
                    fill="#cb4a4a"
                  />
                  <path
                    id="Path_1063"
                    data-name="Path 1063"
                    d="M20.67,9.36H3.93a.93.93,0,0,1,0-1.86H20.67a.93.93,0,1,1,0,1.86Z"
                    transform="translate(200.575 132.97) rotate(-45)"
                    fill="#cb4a4a"
                  />
                </g>
              </svg>
            </button>
            {children}
          </div>
        </div>
      ) : null}
    </>
  );
}
